import { useCookies } from "react-cookie";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

import { logoutAction } from "../redux/slices/authSlice";

export const useLogout = () => {
  const [_, __, removeCookie] = useCookies(["token"]) // eslint-disable-line no-unused-vars
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleLogout = () => {
    removeCookie("token", { path: "/" });
    dispatch(logoutAction());
    navigate("/");
  };

  return { handleLogout };
};